import React, { useCallback } from "react";
import { formatHttpsLink } from "../Utils/helperFunction";
import { useDispatch } from "react-redux";
import { searchBusiness } from "../Redux/Action/BusinessAction/businesAction";
import { useNavigate } from "react-router";
import { loadingAction } from "../Redux/Action/loadingAction";

const CardAds = ({
  width,
  height,
  marginLeft = 32,
  marginBottom = 20,
  data,
  borderRadius = 23.96,
  padding = 0,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user_uuid = localStorage.getItem("user_uuid");
  const handleAdClick = useCallback(async () => {
    if (data) {
      if (data.ext_ad == 1) {
        window.open(formatHttpsLink(data.website), '_blank')
      } else if(data?.business_name?.length > 0) {
        let body = {
          user_uuid: user_uuid,
          lat: localStorage.getItem("latitude") || 21.150058,
          lng: localStorage.getItem("longitude") || 72.8548533,
          range: 50000,
          text: data?.business_name || '',
          page: 1,
          limit: 10,
          business_type: [],
          business_type_name: '',
        };
        try {
          let result = await dispatch(searchBusiness(body));
          if (result.type === "SEARCH_BUSINESS_SUCCESS") {
            dispatch(loadingAction(false));
            navigate("/BusinessSearchResult", {
              state: { result: result.payload, body },
            });
          }
        } catch (error) {
          // console.log(error, "Error");
        }
      }
    }
  }, [data])
  return (
    <div
      className="nib-box"
      onClick={handleAdClick}
      style={{
        // minWidth: "330px",
        cursor: data?.website?.length > 0 || data?.business_name?.length > 0 ?  'pointer' : 'initial',
        position: "relative",
        width,
        height,
        marginLeft,
        marginBottom,
        borderRadius,
        padding,
      }}
    >
      <img
        src={
          data?.image ||
          "https://bgz-business.s3.us-east-2.amazonaws.com/FreeBusinessImage.jpg"
        }
        style={{
          // width: 580,
          width: width,
          objectFit: "cover",
          height: 270,
          borderRadius: "23.96px",
        }}
        alt=""
      />
    </div>
  );
};

export default CardAds;
